<template>
  <div>
    <iframe :src="src"  id="outerHTML" width='100%'  name="ifd"  ref="iframe2"   style="min-height:800px" scrolling="no" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  created(){
    this.getUserInfo()
  },
  data(){
    return {
      userInfo:null,
      src:'',
    }
  },
  methods:{
    getUserInfo(){
      this.userInfo=localStorage.getItem("user")
      this.src=this.$DWSurveyHtmlUrl+'/#/login?userInfo='+this.userInfo+'&type=1'
      console.log(this.userInfo)
    }
  },
  mounted(){
var that = this
const iframe = document.querySelector('#outerHTML')

// 处理兼容行问题
if (iframe.attachEvent) {
iframe.attachEvent('onload', function () {
  // iframe加载完毕以后执行操作

})
} else {
iframe.onload = function () {
  // iframe加载完毕以后执行操作iframe
  console.log('hhhiframe已加载完毕')
//   iframe.style.height =
// that.$refs.iframe2.contentWindow.document.body.scrollHeight + 'px';
//    console.log(iframe.style.height)
   iframe.style.width  = '100%'

}

}

},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/work/teacher/Questionnaire.vue